import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import SKUPickListPopup from '../SKU/SKUPickListPopup.js';
import useSKUPalpaAddCheck from '../SKU/useSKUPalpaAddCheck.js';

const StorageOrderDetailItems=({parentId,application,userData,parent,pageTabCallback,refreshToken})=>{
    const list_name='storage_order_items';
    const executeQuery=useRef(true);
    const {checkPalpaBeforeAdd,palpaPopup}=useSKUPalpaAddCheck(application);

    const pageCallback=async(action,args)=>{
        if(action==='invoke_method'){
            if(args.name==='selectRow'){
                checkPalpaBeforeAdd(args.id,()=>pageTabCallback('invoke_method',{name:'add_sku',args:{sku_id:args.id,order_id:parentId}}));//Palpa warning first, then invoke method on parent order to add item and perform all calculations and refresh
            }
        }
        else if(action==='refresh_parent'){
            pageTabCallback('refresh_data');
        }
    }

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        const rawDeliveryStatus=parent?.delivery_status?.value;
        const translatedDeliveryStatus=rawDeliveryStatus&&application.globalData.list_of_values_reverse.Delivery_Status?.[rawDeliveryStatus];
        return Component?(
            <Component
                parentId={parentId}
                //parent={parent}
                application={application}
                userData={userData}
                entityType={'StorageOrderItem'}
                entityParams={['storage_order_id='+parentId,'_context='+['parent_name=StorageOrder','parent_id='+parentId],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'StorageOrderDetailItems.js'}
                navigateOnNew={null}
                initialState={{}}
                popupComponent={SKUPickListPopup}
                popupComponentQuery={['order_items_filter=Y']}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                refreshToken={refreshToken}
                pageCallback={pageCallback}
                parentContext={{
                    parent_field_name:'storage_order_id',
                    parent_field_value:null,
                    parent_name:'StorageOrder'
                }}
                getRowClassName={(params)=>
                    (translatedDeliveryStatus==='COMPLETED'&&params.row.quantity!==params.row.quantity_delivered)?'highlight-row':''
                }
                dataGridSx={{
                    "& .highlight-row":{
                        backgroundColor:"#ffe6f0 !important",
                        color:"black",
                    },
                    "& .highlight-row .MuiDataGrid-cell[data-field='quantity_delivered']":{
                        color:"darkred",
                    }
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name],refreshToken,parent?.delivery_status?.value]);

    return(<>{palpaPopup}{renderListTab}</>);
}
export default StorageOrderDetailItems;